<template>
  <div class="mobel" v-if="modelType">
    <div class="login">
      <img src="../../images/banner_close.png" @click="goback" class="back" />
      <div class="title">手机号验证</div>
      <div class="tips">为确保您及时收到预约信息，请进行手机号码验证</div>
      <div class="list">
        <input
          placeholder="手机号"
          v-model="mobile"
          type="tel"
          name="mobile"
          maxlength="11"
          pattern="1\d{10}"
        />
      </div>
      <div class="list">
        <input
          placeholder="验证码"
          type="tel"
          v-model="code"
          name="code"
          maxlength="6"
          pattern="1\d{10}"
        />
        <div class="code" @click="getCode">{{codeText}}</div>
      </div>
      <div class="sub" @click="sub">立即验证</div>
    </div>
  </div>
</template>

<script>
import { Toast } from "mint-ui";
export default {
  data() {
    return {
      codeText: "获取验证码",
      mobile: "",
      code: "",
      time: null,
      codeTap: true,
      flag: true,
      modelType: true,
      isDisableLogin: true
    };
  },
  created() {
    let that = this;
    let token114 = localStorage.getItem("token114");
    console.log(token114)
    if (!token114) {
      this.modelType = true;
    } else {
      this.modelType = false;
      this.$emit("close", token114);
    }
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    getCode() {
      //获取验证码
      let that = this;
      var reg = /^1[3456789]\d{9}$/;
      if (!reg.test(this.mobile)) {
        Toast({
          message: "请输入正确的手机号",
          position: "bottom",
          duration: 2000
        });
        return false;
      } else {
        let data = {
          plateform: "dengta",
          op: "getcode",
          type: 14,
          token: this.mobile
        };
        if (!this.codeTap) {
          return false;
        }
        this.codeTap = false;
        that.$http.post("api/hospital-register", data).then(res => {
          let j = res.data;
          this.codeTap = true;
          if (j.code == 200) {
            Toast({
              message: "发送成功",
              position: "bottom",
              duration: 2000
            });
            that.countDown();
          } else {
            Toast({
              message: res.data.error,
              position: "bottom",
              duration: 2000
            });
          }
        });
      }
    },
    countDown() {
      let num = 60;
      let that = this;
      this.time = setInterval(function() {
        num--;
        that.codeTap = false;
        that.codeText = num + "s";
        if (num == 0) {
          that.codeTap = true;
          that.codeText = "重新获取";
          clearInterval(that.time);
        }
      }, 1000);
    },
    sub() {
      let that = this;
      var reg = /^1[3456789]\d{9}$/;
      if (!reg.test(this.mobile)) {
        Toast({
          message: "请输入正确的手机号",
          position: "bottom",
          duration: 2000
        });
        return false;
      }
      if (!this.code) {
        Toast({
          message: "请输入验证码",
          position: "bottom",
          duration: 2000
        });
        return false;
      }
      let data = {
        plateform: "dengta",
        op: "loginx",
        type: 2,
        mobile: this.mobile,
        password: this.code
      };
      if (that.isDisableLogin) {
        that.isDisableLogin = false;
        that.$http.post("api/hospital-register", data).then(res => {
          let j = res.data;
 that.isDisableLogin = true;
          if (j.code == 200) {
            Toast({
              message: "登陆成功",
              position: "bottom",
              duration: 2000
            });
            localStorage.setItem("token114", res.data.data.token);
            this.$emit("close", res.data.data.token);
            that.mobile = "";
            that.code = "";
            that.codeText = "获取验证码";
            that.codeTap = true;
            that.modelType = false;
          } else {
            if (res.data.code == 902) {
              localStorage.setItem("token114", res.data.data.token);
              that.$router.push("/dt/realname");
            }
            Toast({
              message: res.data.error,
              position: "bottom",
              duration: 2000
            });
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.mobel {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(8, 1, 2, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}
.login {
  width: 8rem;
  height: auto;
  padding: 0.533333rem;
  position: relative;
  box-sizing: border-box;
  background: #fff;
  border-radius: 10px;
}
.login .back {
  width: 0.533333rem;
  height: 0.533333rem;
  right: 0.266667rem;
  top: 0.266667rem;
  position: absolute;
}
.login .title {
  width: 100%;
  text-align: center;
  line-height: 0.426667rem;
  font-size: 0.426667rem;
  color: #363636;
  margin-bottom: 0.373333rem;
}
.login .tips {
  font-size: 0.32rem;
  line-height: 0.426667rem;
  text-align: center;

  color: #83889a;
}
.login .list {
  width: 100%;
  height: 1.066667rem;
  margin-top: 0.533333rem;
  padding-right: 0.32rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #e3e3e3;
}

.login .list input {
  display: block;
  flex: 1;
  height: 100%;
  border: none;
  outline: none;
  padding-left: 0.373333rem;
  box-sizing: border-box;
  font-size: 0.4rem;
  width: 1px;
}
.login .list .code {
  font-size: 0.32rem;
  line-height: 0.32rem;
  color: #81888c;
}
.login .sub {
  width: 100%;
  height: 1.066667rem;
  margin-top: 0.533333rem;
  border-radius: 10px;
  text-align: center;
  line-height: 1.066667rem;
  font-size: 0.426667rem;
  color: #fff;
  background: #7fa9fd;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/dt/login_114.vue